// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]8.1-13214(51e81046f0)-C12/10/2026-11:15:06-B12/10/2026-11:22:33' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]8.1-13214(51e81046f0)-C12/10/2026-11:15:06-B12/10/2026-11:22:33",
  branch: "test",
  latestTag: "8.1",
  revCount: "13214",
  shortHash: "51e81046f0",
  longHash: "51e81046f09ff2db13e1d3427a391c856cc90093",
  dateCommit: "12/10/2026-11:15:06",
  dateBuild: "12/10/2026-11:22:33",
  buildType: "Ansible",
  } ;
